import { CurrencyPipe, DecimalPipe, PercentPipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, NgForm } from '@angular/forms';
import { Sort } from '@angular/material/sort';
import { FrameWorkService } from 'src/app/shared/frame-work.service';


@Component({
  selector: 'app-language-mapping',
  templateUrl: './language-mapping.component.html',
  styleUrls: ['./language-mapping.component.scss']
})
export class LanguageMappingComponent implements OnInit {
  @ViewChild('gridContainer', { read: ViewContainerRef, static: true }) gridContainerRef: ViewContainerRef | undefined;
  @ViewChild('gridTemplate', { static: true }) gridTemplateRef: TemplateRef<any> | any;
  @ViewChild('formContainer', { read: ViewContainerRef, static: true }) formContainerRef: ViewContainerRef | undefined;
  @ViewChild('formTemplate', { static: true }) formTemplateRef: TemplateRef<any> | any;
  @ViewChild('toolbarContainer', { read: ViewContainerRef, static: true }) toolbarContainerRef: ViewContainerRef | undefined;
  @ViewChild('toolbarTemplate', { static: true }) toolbarTemplateRef: TemplateRef<any> | any;
  data: { title: string; link: string; cssClass: string; }[] | any;
  pageTitle: string = "List of value Management";
  cultureMappedForm: NgForm | undefined;
  authorsData = [];
  CultureMappingColumns = [{ title: 'Code', key: 'code', type : 'string' }, 
  { title: 'Code Value', key: 'value' , type : 'string' }, 
  { title: 'Type', key: 'typeOfLOV' , type : 'string' }];
  totalRecords: number | undefined;
  perPage: number = 5;
  mappingList: any;
  code: string = "";
  typeOfLOV:string = "";
  isUpdate: boolean | undefined = false;
  recordId: any;
  value: string = "";


  constructor(private fb: FormBuilder, private httpService: FrameWorkService,
    private cdRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.setHeaderConfig();
    this.loadToolBarModule();
    this.loadGridModule();  
    this.getListOfCategory();

  }

  loadGridModule() {
    this.gridContainerRef?.createEmbeddedView(this.gridTemplateRef);
  }

  loadToolBarModule() {
    this.toolbarContainerRef?.createEmbeddedView(this.toolbarTemplateRef);
  }

  loadFromModule() {
    this.formContainerRef?.createEmbeddedView(this.formTemplateRef);
  }

  setHeaderConfig() {
    this.data = []
  }

  createForm() {
    this.code = "";
    this.recordId = "";
    this.typeOfLOV = "";
    this.value = "";
    this.isUpdate = false;
    this.gridContainerRef?.clear();
    this.loadFromModule();
  }

  cancel() {
    this.formContainerRef?.clear();
    this.loadGridModule();
    this.toolbarContainerRef?.clear();
    this.loadToolBarModule();
  }

  addRow(formvalue : any) {
    if(!this.isUpdate) {
      this.httpService.createNewMappingLanguage(formvalue.value).then(res => {
        console.log(res);
        this.httpService.openSnankBar('Successfully added LOV Record')
        this.formContainerRef?.clear();
        this.loadGridModule();
        this.toolbarContainerRef?.clear();
        this.loadToolBarModule();
      }).catch(error => {
        console.log(error);
        this.httpService.openSnankBar('Something went wrong!')
      })
    } else {
      this.httpService.updateMappingLanguage(this.recordId, formvalue.value)
      this.httpService.openSnankBar('Successfully updated LOV Record');
      this.formContainerRef?.clear();
      this.loadGridModule();
    }
  }

  getListOfCategory() {
    this.httpService.getMappingLanguageList().subscribe(data => {
      console.log(data);
      this.mappingList = data
    })
  }


  getEditRowValue(value: any) {
    this.isUpdate = true;
    this.gridContainerRef?.clear();
    this.code = value.item.code;
    this.typeOfLOV = value.item.typeOfLOV
    this.recordId = value.item.id
    this.value = value.item.value;
    this.loadFromModule();
  }

  deleteCategoryRecord(value:any) {
    if(confirm("Are you sure to delete "+value.item.code)) {
      console.log("Implement delete functionality here");
    this.httpService.deleteMappingLanguage(value.item.id);
    this.getListOfCategory();
    }
  }

  refreshGrid() {
    this.loadGridModule();
  }

}

